import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Box,
  Typography,
  Chip,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import {
  Close as CloseIcon,
  Fullscreen as FullscreenIcon,
  FullscreenExit as FullscreenExitIcon,
} from "@mui/icons-material";
import ContractPaymentTable from "./ContractPaymentTable";
import { formatDate } from "utils/formatters";

const PaymentDetailModal = ({
  open,
  onClose,
  paymentProfile,
  contractItems,
  onRefresh,
}) => {
  const [isFullscreen, setIsFullscreen] = useState(false);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const handleFullscreenToggle = () => {
    setIsFullscreen(!isFullscreen);
  };

  const handleClose = () => {
    setIsFullscreen(false);
    onClose();
  };

  if (!paymentProfile) return null;

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth={isFullscreen ? false : "xl"}
      fullWidth
      fullScreen={isFullscreen || isMobile}
      PaperProps={{
        sx: {
          border: "1px solid #e0e0e0",
          boxShadow: "none",
          borderRadius: isFullscreen ? 0 : 2,
          height: isFullscreen ? "100vh" : "90vh",
          maxHeight: isFullscreen ? "100vh" : "90vh",
        },
      }}
    >
      {/* Header */}
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          fontFamily: "Inter, sans-serif",
          fontSize: "1.25rem",
          fontWeight: 600,
          borderBottom: "1px solid #e0e0e0",
          py: 2,
          px: 3,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Typography
            variant="h6"
            sx={{
              fontFamily: "Inter, sans-serif",
              fontWeight: 600,
              color: "#333",
            }}
          >
            Chi tiết kỳ thanh toán
          </Typography>
          <Chip
            // label={dayjs(paymentProfile.paymentDate).format("DD/MM/YYYY")}
            label={formatDate(paymentProfile.paymentDate)}
            size="small"
            color="primary"
            variant="outlined"
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {/* Fullscreen toggle - chỉ hiển thị trên desktop */}
          {!isMobile && (
            <IconButton
              onClick={handleFullscreenToggle}
              size="small"
              sx={{ color: "#666" }}
            >
              {isFullscreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
            </IconButton>
          )}

          <IconButton onClick={handleClose} size="small" sx={{ color: "#666" }}>
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>

      {/* Payment Profile Info */}
      <Box
        sx={{
          px: 3,
          py: 2,
          backgroundColor: "#f8f9fa",
          borderBottom: "1px solid #e0e0e0",
        }}
      >
        <Typography
          variant="h6"
          sx={{
            fontFamily: "Inter, sans-serif",
            fontWeight: 600,
            mb: 1,
          }}
        >
          {paymentProfile.paymentName}
        </Typography>

        <Box sx={{ display: "flex", gap: 3, flexWrap: "wrap" }}>
          <Typography variant="body2" color="text.secondary">
            <strong>Ngày thanh toán:</strong>{" "}
            {/* {dayjs(paymentProfile.paymentDate).format("DD/MM/YYYY")} */}
            {formatDate(paymentProfile.paymentDate)}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            <strong>VAT:</strong> {paymentProfile.vat}%
          </Typography>
          {paymentProfile.notes && (
            <Typography variant="body2" color="text.secondary">
              <strong>Ghi chú:</strong> {paymentProfile.notes}
            </Typography>
          )}
        </Box>
      </Box>

      {/* Content */}
      <DialogContent
        sx={{
          p: 3, // Thêm padding để tạo khoảng cách với dialog
          overflow: "hidden",
          display: "flex",
          flexDirection: "column",
          height: "100%",
        }}
      >
        <Box sx={{ flex: 1, overflow: "auto" }}>
          <ContractPaymentTable
            paymentProfile={paymentProfile}
            contractItems={contractItems}
            onRefresh={onRefresh}
            isInModal={true} // Thêm prop để ContractPaymentTable biết nó đang trong modal
          />
        </Box>
      </DialogContent>

      {/* Footer */}
      <DialogActions
        sx={{
          px: 3,
          py: 2,
          borderTop: "1px solid #e0e0e0",
          backgroundColor: "#f8f9fa",
        }}
      >
        <Typography
          variant="body2"
          color="text.secondary"
          sx={{ flex: 1, fontFamily: "Inter, sans-serif" }}
        >
          💡 Tip: Sử dụng nút fullscreen để xem chi tiết tốt hơn
        </Typography>

        <Button
          onClick={handleClose}
          variant="outlined"
          sx={{
            textTransform: "none",
            fontFamily: "Inter, sans-serif",
            borderColor: "#e0e0e0",
            color: "#666",
            "&:hover": {
              borderColor: "#b0b0b0",
              backgroundColor: "#f5f5f5",
            },
          }}
        >
          Đóng
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default PaymentDetailModal;
